<template>
  <div v-if="content" class="nav-promo-item-colour-collection mb-8">
    <LinkTag
      @click.native="handleClick"
      interstitial
      :to="getLink"
      class="nav-promo-item-colour-collection__link"
    >
      <div
        class="nav-promo-item-colour-collection__layout flex--row-start-center"
      >
        <div class="nav-promo-item-colour-collection__image-holder">
          <bleach-image
            v-if="content.background && content.background[0]"
            class="nav-promo-item-colour-collection__image"
            :src="content.background[0].original_secure_url"
            :sizes="{
              sm: [80, 'ar_1'],
              md: [80, 'ar_1']
            }"
            :default-size="[80, 'ar_1']"
            :alt="content.linkTitle || content.title"
          />
        </div>
        <div
          class="nav-promo-item-colour-collection__text-holder flex--col-center-start"
        >
          <div
            class="nav-promo-item-colour-collection__title text-commerce-tag text--clr-black"
          >
            {{ content.linkTitle || content.title }}
          </div>
        </div>
      </div>
    </LinkTag>
  </div>
</template>

<script>
import GTMAPI from "@/integration/GTMAPI"

export default {
  props: {
    content: Object
  },

  methods: {
    handleClick() {
      GTMAPI.trackEvent("navigation.promo.clicked", {
        item_title: this.content.title
      })
    }
  },

  computed: {
    getLink() {
      return {
        name: this.content.__typename,
        params: { slug: this.fullSlugFromEntry(this.content) }
      }
    }
  }
}
</script>

<style lang="scss">
.nav-promo-item-colour-collection {
  width: 100%;
  height: 24px;

  @include media-breakpoint-up(xl) {
    height: 30px;
  }

  &__link,
  &__layout {
    width: 100%;
    height: 100%;
  }

  &__image-holder {
    position: relative;
    flex: 0 0 30px;
    width: 30px;
    height: 100%;
    background-color: getcolour(bleach_grey_90);

    @include media-breakpoint-up(xl) {
      flex: 0 0 40px;
      width: 40px;
    }
  }

  &__image {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &__text-holder {
    flex: 1 0 auto;
    padding-left: 12px;

    @include media-breakpoint-up(xl) {
      padding-left: 16px;
    }
  }
}
</style>
